import classNames from "classnames";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { ExpandCollapseButton } from "../components/expand-collapse-button.js";
import { COLLAPSIBLE_LIST_ITEM } from "../data-hooks.js";
import classes from "../statics/styles/collapsible-list-pair-scss.js";
import { CollapsibleListContext } from "./collapsible-list-context.js";
const CollapsibleListItem = ({ node, RicosNodesRenderer }) => {
  const { isExpanded: isItemExpanded, toggle } = useContext(CollapsibleListContext);
  const { t } = useContext(RicosContext);
  const isExpanded = isItemExpanded(node.id);
  if (!node.nodes || node.nodes.length === 0) {
    return null;
  }
  const [firstChild, ...restOfChildren] = node.nodes ?? [];
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(classes.itemContainer, classes.itemContainerViewer),
      "data-hook": `${COLLAPSIBLE_LIST_ITEM} ${isExpanded ? "expanded" : "collapsed"}`
    },
    /* @__PURE__ */ React.createElement("div", { className: classes.expandIcon }, /* @__PURE__ */ React.createElement(
      ExpandCollapseButton,
      {
        isExpanded,
        onClick: () => toggle(node.id),
        ariaLabel: isExpanded ? t("CollapsibleListPlugin_ExpandButton_AriaLabel") : t("CollapsibleListPlugin_CollapseButton_AriaLabel")
      }
    )),
    /* @__PURE__ */ React.createElement("div", { className: classes.item }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: [firstChild] }), /* @__PURE__ */ React.createElement("div", { className: isExpanded ? void 0 : classes.childrenHidden }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: restOfChildren })))
  ));
};
const CollapsibleListItemRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(CollapsibleListItem, { key: node.id, node, ...props });
};
var collapsible_list_item_default = CollapsibleListItemRenderer;
export {
  collapsible_list_item_default as default
};
//# sourceMappingURL=collapsible-list-item.js.map
